/* This is ment to build provide a quick starting point when starting new index type file */
import React from 'react';
import mobRoundScreenStyle from './style';

export default function MobRoundScreen({title, isNumbered, rounds}) {
	let style = mobRoundScreenStyle();

	return (
		<div style={style.outerStyle()}>
			<h1 style={style.titleStyle()}>{title}</h1>
			{rounds ? (
				rounds.map((round, i) => {
					return <Round round={round} i={i} />;
				})
			) : (
				<></>
			)}
		</div>
	);

	function Round({round, i}) {
		let entries = round.length + (isNumbered ? 1 : 0);
		let isEven = i % 2 !== 0;

		return (
			<div className={style.mobRoundContainerClasses({isEven: isEven})} style={style.mobRoundContainerStyle()}>
				<div style={style.mobBorderMaker()}>
					{round ? (
						round.map((entry, j) => {
							let isNumber = isNumbered ? (j === 0 ? true : false) : false;
							return (
								<>
									<div>
										{isNumber ? <p style={style.mobGenericText({isNumber: true, isHeader: true})}>{i + 1}</p> : <></>}
										<p style={style.mobGenericText({isNumber: false, isHeader: true})}>{entry.header}</p>
										<p style={style.mobGenericText({isNumber: false, isHeader: false})}>{entry.value}</p>
									</div>
								</>
							);
						})
					) : (
						<></>
					)}
				</div>
			</div>
		);
	}
}
